var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulma admin"},[_c('navbar'),_vm._v(" "),_c('section',{staticClass:"main-content columns is-fullheight"},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"container column is-9"},[(_vm.$route.path === '/admin')?_c('div',[_c('home')],1):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.path})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9e7ac4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/pages/Admin.vue
// module id = null
// module chunks = 